/* eslint-disable react/jsx-props-no-spreading */
import { arrayOf, number, oneOfType, string } from "prop-types";
import { useSelector } from "react-redux";

import ErrorComponent from "web/Layout/Common/ErrorComponent";
import Loading from "web/Layout/Common/Loading";

import { useDataCachedAttributes } from "web/hooks/useDataCached";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";
import mergeLabelsAttributes from "web/utils/page/product/universal/mergeLabelsAttributes";

export default (WrappedComponent) => {
  const WithLabel = ({ ids, code, ...restProps }) => {
    const storeConfig = useSelector((state) => state.app.storeConfig);
    const { data, error, loading } = useDataCachedAttributes({
      ids: ["product_label"],
      storeId: storeConfig?.id,
      token: storeConfig?.token,
    });

    if (error) {
      return <ErrorComponent />;
    }
    if (loading) {
      return <Loading />;
    }

    if (data && data.length) {
      const attribute = isArrayHasItems(data) ? data[0] : {};
      const attributeOptions =
        attribute && attribute.attribute_options
          ? attribute.attribute_options
          : [];
      const labels = mergeLabelsAttributes(attributeOptions, ids);
      const currentLabelData = isArrayHasItems(labels)
        ? labels.find((label) => label && label.code === code)
        : null;

      return currentLabelData && currentLabelData.label ? (
        <WrappedComponent {...restProps} label={currentLabelData.label} />
      ) : null;
    }

    return null;
  };

  WithLabel.propTypes = {
    ids: arrayOf(oneOfType([number, string])).isRequired,
    code: string.isRequired,
  };

  return WithLabel;
};
